import styled from 'styled-components';
import { GRUNDFOS_BLUE, ATTENTION_BLUE, BLUE3, ERROR_RED } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE, FONT_WEIGHT } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const ChatInput = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 10px 12px 10px 18px;
  background: white;
  border-radius: 16px;
  border: 1.5px solid #e4e9ef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  max-width: 800px;
  margin: 0 auto 16px;
  width: calc(100% - 48px);
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;

  &:focus-within {
    border-color: ${GRUNDFOS_BLUE};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(17, 73, 123, 0.08);
  }

  ${MEDIA.MOBILE} {
    width: calc(100% - 24px);
    padding: 8px 10px 8px 14px;
    margin: 0 auto 8px;
    border-radius: 12px;
  }
`;

export const ChatInput__TextArea = styled.textarea`
  flex: 1;
  padding: 10px 0;
  border: none;
  background: transparent;
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: ${FONT_WEIGHT.REGULAR};
  resize: none;
  field-sizing: content;
  min-height: 44px;
  max-height: 150px;
  outline: none;
  line-height: 1.5;
  box-sizing: border-box;
  overflow-y: auto;
  color: #1a1a2e;

  &::placeholder {
    color: #a8b2bc;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${MEDIA.MOBILE} {
    padding: 10px 50px 10px 0;
    font-size: ${FONT_SIZE.SMALL};
    min-height: 40px;
    max-height: 120px;
  }
`;

export const ChatInput__SendBtn = styled.button<{ $disabled: boolean }>`
  width: 44px;
  height: 44px;
  font-size: 18px;
  border-radius: 12px;
  border: none;
  background: ${props => props.$disabled ? '#edf0f3' : ATTENTION_BLUE};
  color: ${props => props.$disabled ? '#b0bec5' : 'white'};
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(18, 106, 243, 0.35);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  ${MEDIA.MOBILE} {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 36px;
    height: 36px;
    font-size: 16px;
    border-radius: 10px;

    &:hover:not(:disabled) {
      transform: none;
      box-shadow: 0 2px 8px rgba(18, 106, 243, 0.3);
    }
  }
`;

export const ChatInput__CharCount = styled.div<{ $warning: boolean }>`
  position: absolute;
  bottom: 14px;
  right: 66px;
  font-size: 11px;
  color: ${props => props.$warning ? ERROR_RED : BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  pointer-events: none;

  ${MEDIA.MOBILE} {
    display: none;
  }
`;

export const ChatInput__SendIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(-45deg);
`;
